<template>
  <app-page-subsection
    v-if="course.audience.length > 0"
    id="audience"
    class="@container"
    :title="{ tag: 'h3', text: title ?? $t('course.page.audience_title') }"
  >
    <ul
      class="relative flex snap-x snap-proximity gap-6 overflow-x-auto @lg:grid @lg:grid-cols-2 @3xl:grid-cols-3"
    >
      <app-card
        v-for="item in course.audience"
        :key="item.id!"
        class="flex shrink-0 basis-[300px] snap-start flex-col gap-2 border p-6"
        tag="li"
      >
        <app-icon v-if="item.icon" :icon="item.icon" :size="48" />

        <p class="text-xl font-semibold">
          {{ item.title }}
        </p>
        <p class="text-subtle">
          {{ item.description }}
        </p>
      </app-card>
    </ul>

    <div class="mt-6">
      <app-check-list
        v-if="course.requirements.length > 0"
        :icon-size="18"
        :items="course.requirements"
        markdown
      />
      <p v-else>
        {{ $t("course.page.requirements_empty_label") }}
      </p>
    </div>
  </app-page-subsection>
</template>

<script lang="ts" setup>
import type { I18nMessage } from "@pollen/core/model/i18n.model";

defineProps<{
  course: Pick<DatabaseTable<"courses">, "audience" | "requirements">;
  title?: I18nMessage;
}>();
</script>
